import { Controller } from "@hotwired/stimulus"

function focusInput(input) {
  const length = input.value.length

  input.focus()
  input.setSelectionRange(length, length)
}

export default class extends Controller {
  get firstInput() {
    return this.element.querySelector(
      "input[type='text']",
      "input[type='email']",
      "input[type='number']",
      "textarea"
    )
  }

  connect() {
    if (this.element.tagName !== "FORM") {
      return
    }

    const input = this.firstInput
    if (!input)
      return

    setTimeout(() => { focusInput(input) }, 300)
  }
}
